import React from 'react';
import { View } from 'react-native';
import { Text } from 'react-native-paper';
import { MoreCircle, TickCircle, CloseCircle } from 'iconsax-react-native';

export default function InspectionCard({ data }){

  return (
    <View style={{ flex: 1, backgroundColor: '#fff', elevation: 2, borderRadius: 8, padding: 12, marginBottom: 8 }}>
      <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
        {
          data.statusShow === 'تایید شده' ?
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <TickCircle size="24" color="#3C9A4F" variant="Bold"/>
              <Text style={{ fontSize: 12, marginLeft: 8, color: '#3C9A4F' }}>تایید شده</Text>
            </View>
          :
            data.statusShow === 'در حال بررسی!' ?
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <MoreCircle size="24" color="#FFA200" variant="Bold"/>
                <Text style={{ fontSize: 12, marginLeft: 8, color: '#FFA200' }}>در انتظار بررسی!</Text>
              </View>
            :
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <CloseCircle size="24" color="#D61600" variant="Bold"/>
                <Text style={{ fontSize: 12, marginLeft: 8, color: '#D61600' }}>رد شده</Text>
              </View>
        }
      </View>
      <View style={{ marginTop: 12, marginBottom: 11, paddingBottom: 11, borderBottomColor: '#EBEBEB', borderBottomWidth: 1 }}>
        <Text style={{ fontSize: 12, color: '#879CA6', fontFamily: 'IRANSans_Medium' }}>توضیحات:</Text>
        <Text style={{ fontSize: 12, color: '#4D4D4D', marginTop: 4 }}>{data.des}</Text>
      </View>
      <View style={{ marginBottom: 11, paddingBottom: 11, borderBottomColor: '#EBEBEB', borderBottomWidth: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
        <Text style={{ fontSize: 12, color: '#879CA6', fontFamily: 'IRANSans_Medium' }}>آدرس:</Text>
        <Text style={{ fontSize: 12, color: '#3F3E3D', marginTop: 4, fontFamily: 'IRANSans_Medium' }}>{data.address}</Text>
      </View>
      <View style={{ marginBottom: 11, paddingBottom: 11, borderBottomColor: '#EBEBEB', borderBottomWidth: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
        <Text style={{ fontSize: 12, color: '#879CA6', fontFamily: 'IRANSans_Medium' }}>منطقه:</Text>
        <Text style={{ fontSize: 12, color: '#3F3E3D', marginTop: 4, fontFamily: 'IRANSans_Medium' }}>{data.region?.mantaghe}</Text>
      </View>
      <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
        <Text style={{ fontSize: 12, color: '#879CA6', fontFamily: 'IRANSans_Medium' }}>تاریخ ثبت:</Text>
        <Text style={{ fontSize: 12, color: '#3F3E3D', marginTop: 4, fontFamily: 'IRANSans_Medium' }}>{data.timeAgo}</Text>
      </View>
    </View>
  );
};